// extracted by mini-css-extract-plugin
module.exports = {"fab":"EstatePrint-module--fab--3Ls7s"};